import { Input } from '../../../components/react-hook-form-6/input';
import { Dropdown } from '../../../components/dropdown';
import { useForm } from 'react-hook-form-6';
import { Button } from 'components/button';
import { CreatableDropdown } from 'components/creatable-dropdown';
import { ContentFilterGroupsScreenQuery } from 'graphql/types';

export const CreateFilterGroup = ({
  onClose,
  contentTags,
  onCreateFilterGroup,
  loading,
}: {
  onClose: () => void;
  contentTags: ContentFilterGroupsScreenQuery['contentTags'];
  onCreateFilterGroup: ({
    title,
    contentCategoryId,
    filterItems,
  }: {
    title: string;
    contentCategoryId: string;
    filterItems: string[];
  }) => void;
  loading: boolean;
}) => {
  const { control, handleSubmit, register, errors } = useForm<{
    title: string;
    contentCategoryId: string;
    filterItems: { value: string; label: string; __isNew__: boolean }[];
  }>();

  const onSubmit = handleSubmit(
    async ({
      title,
      contentCategoryId,
      filterItems,
    }: {
      title: string;
      contentCategoryId: string;
      filterItems: { value: string; label: string; __isNew__: boolean }[];
    }) => {
      onCreateFilterGroup({
        title,
        contentCategoryId,
        filterItems: filterItems.map((item) => item.value),
      });
    },
  );

  return (
    <div>
      <h2 className="heading-md mb-5">Create Filter Group</h2>
      <form onSubmit={onSubmit}>
        <div className="flex flex-col space-y-8">
          <Input
            name="title"
            label="Title"
            ref={register({ required: true })}
            errorMessage={errors.title?.message}
          />
          <Dropdown
            name="contentCategoryId"
            label="Content Category"
            control={control}
            rules={{ required: true }}
            errorMessage={errors.contentCategoryId?.message}
            options={
              contentTags?.map((tag) => ({
                label: tag.name,
                value: tag.id,
              })) ?? []
            }
          />
          <CreatableDropdown
            name="filterItems"
            label="Filter Items"
            control={control}
            options={[]}
            tooltip={{
              hoverText: 'Optionally add filter items to the filter group',
            }}
          />
          <div className="flex flex-row space-x-4">
            <Button fullWidth variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button
              fullWidth
              color="success"
              loading={loading}
              disabled={loading}
              type="submit"
            >
              Add and preview
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};
